import * as React from 'react';
import { Tutorial } from 'components/Tutorial/Tutorial';

export const TutorialCards: React.FC = () => {
  return (
    <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
      <Tutorial
        title="Getting Started: Disputing Per Diem Video Tutorial"
        description="Learn how to retrieve your per diem reports and dispute your invoices with our video and pdf guides."
        tutorialDuration="3:59"
        tutorialKey="perdiem-video"
        youtubeURL="https://www.youtube.com/embed/ZayUwWOBGmM"
        segmentKey="per diem"
      />
      <Tutorial
        title="Getting Started: A 3-Step Process to Dispute Per Diem"
        description={
          <span className="leading-6">
            1. Audit received invoice from SSLs
            <br />
            2. Dispute with SSL using Per Diem Archive screenshots
            <br />
            3. Defend your dispute by referring to appropriate legal guidelines
          </span>
        }
        tutorialDuration=""
        tutorialKey="perdiem-guide"
        segmentKey="per diem"
      />
    </div>
  );
};
